export default function pad(value) {
  return String(value).padStart(2, '0');
}
